var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "epf-filter-product" },
    [
      _c("div", { staticClass: "epf-filter-product__title" }, [
        _vm._v(_vm._s(_vm.filterConfig.title)),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "epf-filter-product__wrap" },
        [
          _vm.selectedOption
            ? [
                _c(
                  "div",
                  { staticClass: "epf-filter__select__selection" },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.selectedOption.data.title) +
                        "\n                    "
                    ),
                    _c("global-button", {
                      staticClass: "epf-filter__select__clear",
                      attrs: {
                        icon: "close",
                        theme: "primary",
                        disabled: _vm.freeze,
                      },
                      on: { click: _vm.onClearSelection },
                    }),
                  ],
                  1
                ),
              ]
            : _c(
                "global-button",
                {
                  staticClass: "button--spread",
                  attrs: { theme: "secondary" },
                  on: {
                    click: function ($event) {
                      _vm.modalOpen = true
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("filter.selectProduct")))]
              ),
        ],
        2
      ),
      _vm._v(" "),
      _vm.modalOpen
        ? _c(
            "global-modal",
            { on: { close: _vm.abort } },
            [
              _c("template", { slot: "header" }, [
                _c("div", { staticClass: "epf-filter-product__tab-links" }, [
                  _c(
                    "button",
                    {
                      staticClass: "epf-filter-product__tab-link",
                      class: {
                        "epf-filter-product__tab-link--active": _vm.isModeText,
                      },
                      on: {
                        click: function ($event) {
                          _vm.mode = "text"
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("filter.product.byKeyword")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "epf-filter-product__tab-link",
                      class: {
                        "epf-filter-product__tab-link--active":
                          _vm.isModeFilter,
                      },
                      on: {
                        click: function ($event) {
                          _vm.mode = "filter"
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("filter.product.byFilter")))]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isModeText,
                        expression: "isModeText",
                      },
                    ],
                    staticClass: "row",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "epf-filter__input col-12 col-md-6 col-lg-4",
                      },
                      [
                        _c("div", { staticClass: "epf-filter__title" }, [
                          _vm._v(_vm._s(_vm.filterConfig.title)),
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.text_query,
                              expression: "text_query",
                            },
                          ],
                          staticClass: "search__field",
                          attrs: {
                            type: "text",
                            maxlength: "100",
                            placeholder: _vm.$t(
                              "filter.product.keyword.placeholder"
                            ),
                            disabled: _vm.freeze,
                          },
                          domProps: { value: _vm.text_query },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.text_query = $event.target.value
                            },
                          },
                        }),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isModeFilter,
                        expression: "isModeFilter",
                      },
                    ],
                    staticClass: "row",
                  },
                  [
                    _vm.filterGroup
                      ? _c("epf-filter-select", {
                          attrs: {
                            "filter-config": _vm.filterGroup,
                            "additional-class": "col-12 col-md-4 col-lg-3",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterApplication
                      ? _c("epf-filter-select", {
                          attrs: {
                            "filter-config": _vm.filterApplication,
                            "additional-class": "col-12 col-md-4 col-lg-3",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterMaterial
                      ? _c("epf-filter-select", {
                          attrs: {
                            "filter-config": _vm.filterMaterial,
                            "additional-class": "col-12 col-md-4 col-lg-3",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterSurface
                      ? _c("epf-filter-select", {
                          attrs: {
                            "filter-config": _vm.filterSurface,
                            "additional-class": "col-12 col-md-4 col-lg-3",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("template", { slot: "body" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c(
                        "global-loading-overlay",
                        {
                          attrs: { showLoading: _vm.freeze || _vm.text_freeze },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("filter.product.loading")) +
                              "\n                        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.text_result && _vm.availableProducts.length === 0
                        ? _c("div", [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.$t("filter.product.keyword.noResult")
                                ) +
                                "\n                        "
                            ),
                          ])
                        : [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-12" }, [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm.availableProducts.length) +
                                    " " +
                                    _vm._s(
                                      _vm.$t("filter.product.totalProducts")
                                    ) +
                                    "\n                                "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "row" },
                              _vm._l(
                                _vm.availableProducts,
                                function (product, index) {
                                  return _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.page === _vm.groupTiles(index),
                                          expression:
                                            "page === groupTiles(index)",
                                        },
                                      ],
                                      staticClass:
                                        "col-4 col-md-2 product__col",
                                      class: [
                                        "group--" + _vm.groupTiles(index),
                                        index === _vm.selectedProduct
                                          ? "product__col--selected"
                                          : "",
                                      ],
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "product__col--icon icon-item icon-item--ghost",
                                        },
                                        [
                                          _c("span", {
                                            staticClass:
                                              "icon icon--check-square",
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("global-material-tile", {
                                        attrs: { entity: product.data },
                                        on: {
                                          click: function ($event) {
                                            _vm.selectedProduct = index
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                }
                              ),
                              0
                            ),
                          ],
                    ],
                    2
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "template",
                { slot: "pagination" },
                [
                  _c("span", { staticClass: "pagination__indicator" }, [
                    _vm._v(_vm._s(_vm.productsShown)),
                  ]),
                  _vm._v(" "),
                  _c("global-button", {
                    staticClass: "ignore-context pagination--prev",
                    class: _vm.page - 1 < _vm.lowerEnd ? "disabled" : "",
                    attrs: { icon: "arrow-left", theme: "secondary" },
                    on: {
                      click: function ($event) {
                        return _vm.changePage(_vm.page - 1)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("global-button", {
                    staticClass: "ignore-context pagination--prev",
                    class: _vm.page + 1 > _vm.upperEnd ? "disabled" : "",
                    attrs: { icon: "arrow-right", theme: "secondary" },
                    on: {
                      click: function ($event) {
                        return _vm.changePage(_vm.page + 1)
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "template",
                { slot: "controls__left" },
                [
                  _c(
                    "global-button",
                    { attrs: { theme: "secondary" }, on: { click: _vm.abort } },
                    [_vm._v(_vm._s(_vm.$t("filter.product.close")))]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "template",
                { slot: "controls__right" },
                [
                  _c(
                    "global-button",
                    {
                      attrs: { theme: "primary" },
                      on: { click: _vm.saveAndClose },
                    },
                    [_vm._v(_vm._s(_vm.$t("filter.product.select")))]
                  ),
                ],
                1
              ),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }